export const nullOrNumber = (val) => {
    if (val === null || val === '')
        return null;
    return isNaN(Number(val)) ? null : Number(val);
};
